const mapPackageSelectionFromApi = (packageSelectionResponse) => {
  const {
        shipBobBox
    } = packageSelectionResponse
  return {
    shipBobBox: shipBobBox
  }
}

const mapPackageSelectiontoApi = (formData) => {
  return {
    FulfillmentCenterId: formData.FulfillmentCenterId || 8,
    CountryISO: formData.CountryISO || 'US',
    UserId: formData.userId || 1,
    OrderTypeId: formData.orderTypeId,
    OrderItems: formData.items.map(data => {
      return {
        Length: data.itemLength,
        Width: data.itemWidth,
        Height: data.itemHeight,
        WeightOz: data.itemWeight,
        PackType: data.itemPreference,
        Quantity: data.itemQuantity,
        IsCubiscanned: true
      }
    })
  }
}

export default {
  mapPackageSelectionFromApi,
  mapPackageSelectiontoApi
}

